export const phoneRegExp = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
export const fioRegExp = /^[А-Яа-яA-Za-z.\-\s']+$/
export const authorityCodeRegExp = /\d{3}-\d{3}/
